export default __webpack_public_path__ + "static/media/Specyfikacja_Click&Link_Cubo_duo.b5fc87be.pdf";